import { api } from '@/core/api/';

const URL = 'api/servicecost';

export const getServiceCostFilters = () => api.get(`${URL}/initfilters`);

export const getDisciplinesRP = (serviceTypeId) =>
  api.get(`${URL}/disciplinesrp/${serviceTypeId}`);

export const getSubDisciplinesRP = (subdisciplineTypeId) =>
  api.get(`${URL}/subdisciplinesrp/${subdisciplineTypeId}`);

export const searchServiceCost = (payload) =>
  api.get(`${URL}/searchservicecost`, {
    params: {
      ...payload,
    },
  });

export const saveCost = (payload) => api.post(`${URL}/save`, payload);

export const editCost = (id, payload) => api.put(`${URL}/edit/${id}`, payload);

export const deleteCost = (id) => api.delete(`${URL}/delete/${id}`);
